import { useContext } from "react";
import { RoleBuilderContext } from "components/Missions/Roles/TalentSimple/RoleBuilder/RoleBuilderContext";

/**
 * useRoleBuilderContext - Hook to access the Talent Simple role builder
 * Throws error if used outside RoleBuilderModal
 */
export default function useRoleBuilderContext() {
  const context = useContext(RoleBuilderContext);

  if (!context) {
    throw new Error("useRoleBuilderContext must be used within RoleBuilderModal");
  }

  return context;
}
